export default {"src":"/_next/static/media/empty-wishlist.60b6d372.svg","height":73,"width":80};